module.exports = __webpack_public_path__ + "assets/img/forerunner.ff010e13.png";